import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReplicateInformationStatus, ReplicateInformationTo, ReplicateInformationCollection, ModalDialogType } from 'src/app/@core/constants';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { PosOrderObservationsService } from 'src/app/@core/services/pos-order-observations.service';
import { Branch } from 'src/app/models/branch';
import { ColumnTable } from 'src/app/models/column-table';
import { Customer } from 'src/app/models/customer';
import { Paging } from 'src/app/models/page';
import { ReplicateInformationErrors } from 'src/app/models/replicate-information-errors';
import { ReplicateInformationLog } from 'src/app/models/replication-information-log';
import { BranchesService } from 'src/app/services/branches.service';
import { CustomerService } from 'src/app/services/customer.service';
import { ReplicateInformationService } from 'src/app/services/replicate-information.service';

@Component({
    selector: 'app-replicate-information-details',
    templateUrl: './replicate-information-details.component.html',
    styleUrls: ['./replicate-information-details.component.sass']
})
export class ReplicateInformationDetailsComponent implements OnInit {

    log: ReplicateInformationErrors = new ReplicateInformationErrors();
    innerLogs: Paging<Array<ReplicateInformationLog>> = new Paging([]);
    products: Paging<Array<{ code: string }>> = new Paging([]);
    customer: Customer = new Customer();
    branch: Branch = new Branch();

    constructor(private router: Router, private route: ActivatedRoute, private replicateService: ReplicateInformationService, private branchService: BranchesService, private customerService: CustomerService, private observationModalService: PosOrderObservationsService, private confirmService: PosConfirmationService) {
        const navigation = this.router.getCurrentNavigation();
        if (navigation?.extras.state == undefined) {
            this.router.navigate(['salesforceTransactions']);
        }
        this.log = (navigation?.extras.state!.log as ReplicateInformationErrors) || new ReplicateInformationErrors();
        this.products = new Paging(this.log.productCode?.map(m => { return { code: m } }) ?? []);


    }
    async ngOnInit(): Promise<void> {
        this.products = new Paging(this.log.productCode?.map(m => { return { code: m } }) ?? []);
        if (this.log.customerCode) {
            this.customer = await this.customerService.readCustomerByCode(this.log.customerCode).toPromise();
        }
        if (this.log.branchCode) {
            this.branch = (await this.branchService.readBranch(this.log.branchCode).toPromise()).response;
        }
        this.innerLogs = (await this.replicateService.readReplicateInformationLogByCode(this.log._id).toPromise()).response;
    }

    getBadgeClass(value: string | ReplicateInformationStatus | ReplicateInformationTo | ReplicateInformationCollection) {

        switch (value) {
            //'PREAPPROVE', 'CREDITREQUEST','PROCESSING','SENDFORCSV','SKIPED'
            case ReplicateInformationStatus.PROCESSING:
            case ReplicateInformationStatus.SENDFORCSV:
            case ReplicateInformationStatus.SKIPED:
            case ReplicateInformationCollection.CREDITREQUEST:
            case ReplicateInformationCollection.PREAPPROVE:
                return "badge-warning";
            case ReplicateInformationStatus.FAILED:
                return "badge-danger";
            default:
                return "badge-success";
        }
    }

    getLogHeaders(): Array<ColumnTable> {
        return [
            new ColumnTable("code", "Código"),
            new ColumnTable("processingMessage", "Mensaje"),
            new ColumnTable("status", "Estado", { type: "badge", isSmall: true }),
            new ColumnTable("code", "#", {
                type: "action", iconClass: "fa fa-cogs", isIcon: true, actions: [
                    {
                        fn: async (log: ReplicateInformationLog) => {

                            await this.observationModalService.show(JSON.stringify(log.request, undefined, 4), (obs: string) => { }, true, "Request");
                        },
                        icon: 'fa fa-eye',
                        isDisabled: false,
                        tooltip: 'Ver Request'
                    }
                ]
            })
        ];
    }

    async resendTransaction() {
        const result = await this.confirmService.showAsync("¡Alerta!", `¿Está seguro de reenviar la transacción con código ${this.log.code}?`, ModalDialogType.WARNING);
        if (result) {
            await this.replicateService.resendReplicateTransaction(this.log._id).toPromise();
            this.innerLogs = (await this.replicateService.readReplicateInformationLogByCode(this.log._id).toPromise()).response;
        }
    }
}
